export default __webpack_public_path__ + "static/media/logo-hd.d12b4929.png";